import { ArrowLeftOutlined, CalendarOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Image, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DocumentUI } from "../entity/document.model";
import documentPublicService from "../service/document.service";

const { Title, Text } = Typography;

const DocumentDetail = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const [document, setDocument] = useState<DocumentUI | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (uuid) {
      loadDocument();
    }
  }, [uuid]);

  const loadDocument = async () => {
    setLoading(true);
    try {
      const doc = await documentPublicService.getDocument(uuid!);
      setDocument(doc);
    } catch (error) {
      console.error("Failed to load document:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("mn-MN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleBack = () => {
    if (document?.documentCategory?.uuid) {
      navigate(`/appversion/${document.documentCategory.uuid}`);
    } else {
      navigate(-1);
    }
  };

  return (
    <div style={{ padding: "40px 20px", maxWidth: "900px", margin: "0 auto" }}>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={handleBack}
        style={{ marginBottom: "20px" }}
      >
        Буцах
      </Button>

      <Card loading={loading}>
        {document && (
          <>
            <Title level={2}>{document.title}</Title>

            {document.link && (
              <div style={{ marginBottom: "24px" }}>
                <a style={{ color: "blue", textDecoration: "underline", fontSize: "24px" }} href={document.link} target="_blank" rel="noopener noreferrer">
                  ЭНД ДАРЖ ТАТНА УУ
                </a>
              </div>
            )}

            <div style={{ marginBottom: "24px" }}>
              <Text type="secondary">
                <CalendarOutlined /> {formatDate(document.createdDate)}
                <span style={{ marginLeft: "16px" }}>
                  <UserOutlined /> {document.username}
                </span>
              </Text>
            </div>

            {document.mainImagePath && (
              <div style={{ marginBottom: "24px", textAlign: "center" }}>
                <Image
                  src={document.mainImagePath}
                  alt={document.title}
                  style={{ maxWidth: "100%", maxHeight: "500px" }}
                />
              </div>
            )}

            <div
              style={{
                fontSize: "16px",
                lineHeight: "1.8",
                color: "#333",
              }}
              dangerouslySetInnerHTML={{ __html: document.content }}
            />

            {document.link && (
              <div style={{ marginBottom: "24px" }}>
                <a style={{ color: "blue", textDecoration: "underline", fontSize: "24px" }} href={document.link} target="_blank" rel="noopener noreferrer">
                  ЭНД ДАРЖ ТАТНА УУ
                </a>
              </div>
            )}

          </>
        )}

        {!loading && !document && (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <Text type="secondary">Мэдээлэл олдсонгүй</Text>
          </div>
        )}
      </Card>
    </div>
  );
};

export default DocumentDetail;

